module.exports = __webpack_public_path__ + "static/img/race1.f52a46c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/race1.png
// module id = nJyc
// module chunks = 1 3